import { UseToastProps } from '@eqi-investimentos/react';

export const toastConfigDefault = {
  primary: {
    showIcon: false,
    variant: 'success',
    position: 'top',
  } as UseToastProps,
  neutral: {
    showIcon: false,
    variant: 'neutral',
    position: 'top',
    isClosable: true,
  } as UseToastProps,
  error: {
    showIcon: false,
    variant: 'error',
    position: 'top',
  } as UseToastProps,
};
